import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { LoginSettings } from '@lyceo/homi/login/util-models';

export const LoginSettingsActions = createActionGroup({
  source: 'Login Settings API',
  events: {
    'Get Login Settings': props<{ website: string }>(),
    'Get Login Settings Success': props<{ settings: LoginSettings }>(),
    'Get Login Settings Failure': props<{ error: Error }>(),
  },
});

export const ChooseWebsitePageActions = createActionGroup({
  source: 'Choose Website Page',
  events: {
    'Website Chosen': props<{ website: string }>(),
    'Website Logout': emptyProps(),
  },
});

export const LoginPageActions = createActionGroup({
  source: 'Login Page',
  events: {
    'Clear website': emptyProps(),
  },
});
